module.exports = __webpack_public_path__ + "static/img/the-force-awakens.2455260.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/the-force-awakens.jpg
// module id = mbLn
// module chunks = 0